import { useLoaderData } from "react-router-dom";
import { ListingDetailsView } from "../components/ListingDetailsView";
import type { UnitDetailsPageLoaderType } from "./loaders/UnitDetailsPageLoader";

export const UnitDetailsPage: React.FC = () => {
  const details = useLoaderData() as UnitDetailsPageLoaderType;
  return <ListingDetailsView details={details} />;
};
